import { Status, Wrapper } from '@googlemaps/react-wrapper';
import { Box, Typography } from '@mui/material';
import { type FC, type PropsWithChildren, type ReactElement, useState } from 'react';

import { hasValue } from '@core/utils/equality';

import { SlabConfig } from '../../utils/SlabConfig';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

const MapRenderer = (status: Status): ReactElement => {
  if (status === Status.LOADING) return <LoadingSpinner />;
  if (status === Status.FAILURE) return <Typography>Google Map failed to load</Typography>;

  return <Box />;
};

interface SlabMapConfigWrapperProps extends PropsWithChildren {}

export const SlabMapConfigWrapper: FC<SlabMapConfigWrapperProps> = ({ children }) => {
  const [status, setStatus] = useState<Status | null>(null);

  if (!hasValue(SlabConfig.googleMaps.id) || status === Status.FAILURE)
    return <Typography color='red'>Map cannot load because the API key was not found</Typography>;

  return (
    <Wrapper
      apiKey={SlabConfig.googleMaps.id}
      libraries={['places', 'marker']}
      render={MapRenderer}
      callback={setStatus}
    >
      {children}
    </Wrapper>
  );
};
